import { Pipe, PipeTransform } from '@angular/core';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { GlobalFunction } from 'src/app/shared/global-function';

@Pipe({
  name: 'defaulttranslation'
})
export class DefaultTranslationPipe implements PipeTransform {
  language:string;
  transform(value: any, args:any): any {

    if(value!=null && value.hasOwnProperty('localizations') && value.localizations!=null){
      let defaultLocalization=value.localizations.find(x=>x.languageCode==AppConfigService.appConfig.LocalizationLanguage);
      
      if(defaultLocalization == null )  // this is used because the q-flex uses languageCodes wich can contain multiple codes instead of languageCode
      {

        defaultLocalization = value.localizations.find(x =>{
            let foundElement: any;
            let tmp = x.languageCodes.split(',');
            tmp.forEach(element => {
                element.trim();
                if(element == AppConfigService.appConfig.LocalizationLanguage)
                {
                    foundElement = x; 
                    return true;
                }
            });
            if(!GlobalFunction.isEmpty(foundElement))
            {
                return foundElement;
            }
        });
      }   
      if(defaultLocalization!=null){
        return defaultLocalization[args];
      }
    }
    return null;
  }

}
